// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { LogLevel } from '@core/logger';
import { EnvironmentBase } from '@env/environment.base';
import { LoginBehaviour } from '@env/LoginBehaviour';

export const environment: EnvironmentBase = {
  name: 'pasm',
  MultiMandantConfigs: [
    {
      host: 'pas-kpt-smartportal-frontend-uat.pasmapps.de',
      pathToAssets: 'https://pas-kpt-smartportal-frontend-uat.pasmapps.de/assets/pasm',
    },
  ],
  baseUrl: 'https://pas-kpt-smartportal-backend-uat.pasmapps.de',
  production: true,
  logLevel: LogLevel.All,
  hmr: false,
  AadClientId: 'c7018695-900b-4137-b4ca-f19e4d27ecc0',
  AadScope: 'https://pasb2cdev.onmicrosoft.com/pas-kpt-smartportal-backend-uat/API.ACCESS',
  AadAuthorityDomain: 'pasb2cdev.b2clogin.com',
  AadSignupSigninUrl:
    'https://pasb2cdev.b2clogin.com/pasb2cdev.onmicrosoft.com/B2C_1A_SOCIAL_SIGNIN_KPT',
  AadEditprofileUrl: 'https://pasb2cdev.b2clogin.com/pasb2cdev.onmicrosoft.com/B2C_1_PasswordReset',
  LoginButtonBehaviour: LoginBehaviour.B2C,
  buildNumber: '261015.1304',
};
